


























import { WebPartContext } from "@microsoft/sp-webpart-base";
import { AadTokenProvider } from "@microsoft/sp-http";
import moment from "moment";
import { extend } from "vee-validate";
import { email, required, numeric, max, min } from "vee-validate/dist/rules";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import i18n from "./locale";
import ErrorDialog from "./views/components/common/ErrorDialog.vue";

extend("my-date-after-now", {
  validate: (value) => {
    const now: moment.Moment = moment(new Date(), "DD-MM-YYYY HH:mm", true);
    const date: moment.Moment = moment(value, "DD-MM-YYYY HH:mm", true);
    return date.isAfter(now, 'minute');
  },
  message: i18n.t("message.invalid_date_time").toString(),
});

extend("my-time-variable", {
  validate: (value) => {
    const valArr = ("" + value).match(/^[0-9]\d.(((0|1)[0-9])|2[0-3]):[0-5][0-9]:[0-5][0-9]$/);
    return valArr && valArr.length > 0;
  },
  message: i18n.t("message.invalid").toString(),
});

extend("my-the-mask-variable", {
  validate: (value) => {
    const valArr = ("" + value).match(/^[0-9]\d(((0|1)[0-9])|2[0-3])[0-5][0-9][0-5][0-9]$/);
    return valArr && valArr.length > 0;
  },
  message: i18n.t("message.invalid").toString(),
});

extend("my-date", {
  validate: (value) => {
    const date = moment(value, "YYYY-MM-DD", true);
    return date.isValid();
  },
  message: i18n.t("message.invalid").toString(),
});

extend("my-date-after", {
  params: ["target", "errorCode"],
  validate: (value: string, { target }: { target: string }) => {
    const date = moment(value, "YYYY-MM-DD", true);
    const other = moment(target, "YYYY-MM-DD", true);
    return date.isValid() && other.isValid && date.isSameOrAfter(other);
  },
  message: (fieldName, placeholders) => {
    return i18n.t(`message.${placeholders.errorCode}`).toString();
  },
});

extend("my-required", {
  ...required,
  message: i18n.t("message.required").toString(),
});

extend("email-invalid", {
  ...email,
  message: i18n.t("message.invalid").toString(),
});

extend("field-numeric", {
  ...numeric,
  message: i18n.t("message.field_numberic").toString(),
});

extend("field-required", {
  ...required,
  message: i18n.t("message.field_required").toString(),
});

extend("max-lenght", {
  ...max,
  message: i18n.t("message.max_lenght").toString(),
});
extend("phoneNumberic", {
  ...numeric,
  message: i18n.t("message.phoneNumber_numberic").toString(),
});
extend("my-email", {
  ...email,
  message: i18n.t("message.email").toString(),
});
@Component({
  components: {
    ErrorDialog,
  },
})
export default class Todo extends Vue {
  @Prop() token?: string;
  @Prop() email?: string;
  @Prop() fullName?: string;
  @Prop() context?: any;

  showLoading = false;
  showRouting = false;

  get routing() {
    return this.$store.getters.routing;
  }

  get loading() {
    return this.$store.getters.loading;
  }

  @Watch("routing")
  onRoutingWatch(val: boolean) {
    if (val) {
      this.showRouting = true;
    } else {
      setTimeout(() => {
        this.showRouting = false;
      }, 200);
    }
  }

  @Watch("loading")
  onLoadingWatch(val: boolean) {
    if (val) {
      this.showLoading = true;
    } else {
      setTimeout(() => {
        this.showLoading = false;
      }, 200);
    }
  }

  // onCancel() {
  //   // this.showLoading = false;
  //   this.$store.commit("LOADING_HIDE");
  // }

  beforeCreate() {
    this.$store.commit("SET_SP_USER_INFO", {});
  }

  async created() {
    console.log("App.vue props: ", this.$props);
    // Get on Webpart duplicate con sharepoint
    // let token = "";
    // try {
    //   if (this.context) {
    //     const tokenProvider = await (
    //       this.context as WebPartContext
    //     ).aadTokenProviderFactory.getTokenProvider();
    //     token = await tokenProvider.getToken(
    //       "https://graph.microsoft.com",
    //       false
    //     );
    //   }
    // } catch (error) {
    //   console.log("created: ", error);
    // }

    this.$store.commit("SET_SP_USER_INFO", {
      email: this.email,
      token: this.token,
      fullName: this.fullName,
    });
  }
}
